import { ICommand } from 'core-ts-types';
import { isFunction, pick } from 'lodash4';
class SaveGeneratedTermButton {
  private terms: any[];
  private callBackAfterSaving: () => void;
  private buttonType: string;

  constructor(private saveTermPreviewPlanCommand: ICommand, private ngPreviewTermPlanModel: any) {}
  savePlan() {
    const currentTermPlanShowing = pick(this.ngPreviewTermPlanModel.read(), [
      'planned_course_groups',
      'planned_courses',
      'student_planned_terms'
    ]);
    this.saveTermPreviewPlanCommand(currentTermPlanShowing).then(
      () => isFunction(this.callBackAfterSaving) && this.callBackAfterSaving()
    );
  }
}

angular.module('capability-ng-academic-planner').component('saveGeneratedTermButton', {
  templateUrl:
    'capability-ng-academic-planner/src/preferences/components/preview_plan/components/save_generated_term_button/save_generated_term_button.html',
  bindings: {
    terms: '<',
    callBackAfterSaving: '&',
    type: '<'
  },
  controller: SaveGeneratedTermButton
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/components/save_generated_term_button/save_generated_term_button.ts